"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRASH_FOLDER_ID = exports.TRASH_DAYS = void 0;
const url_utils_1 = require("@zapier/url-utils");
const urlParams = typeof window !== 'undefined' ? url_utils_1.extractParams(window.location.href) : {};
const DEBUG_TRASH_DAYS = parseInt(urlParams.DEBUG_TRASH_DAYS);
exports.TRASH_DAYS = isNaN(DEBUG_TRASH_DAYS) ? 30 : DEBUG_TRASH_DAYS;
exports.TRASH_FOLDER_ID = 'trash';
